import { StateCreator } from 'zustand'
import { type CampaignCreationState } from '../state'

export interface NavigationSlice {
    currentStep: number
    setCurrentStep: (step: number) => void
    nextStep: () => void
    prevStep: () => void
}

export const createNavigationSlice: StateCreator<
    CampaignCreationState,
    [],
    [],
    NavigationSlice
> = (set) => ({
    currentStep: 1,
    setCurrentStep: (step: number) => set({ currentStep: step }),
    nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
    prevStep: () =>
        set((state) => ({ currentStep: Math.max(1, state.currentStep - 1) })),
})
